import { Component } from '@angular/core';

@Component({
  selector: 'ncp-view',
  imports: [],
  templateUrl: './view.component.html',
  styleUrl: './view.component.scss',
})
export class ViewComponent {

}
